<ng-container *ngIf="place === 'store'">
    {{ (status === 'NoStock'
            ? 'stock.inStore.noStockStatus'
            : status === 'Few'
                ? 'stock.inStore.lowStockStatus'
                : status === 'InStock'
                    ? 'stock.inStore.inStockStatus'
                    : 'stock.unknownStockStatus'
    ) | translateSafe
    }}
</ng-container>

<ng-container *ngIf="place === 'online'">
    {{ (status === 'NoStock'
            ? 'stock.online.noStockStatus'
            : status === 'Few'
                ? 'stock.online.lowStockStatus'
                : status === 'InStock'
                    ? 'stock.online.inStockStatus'
                    : 'stock.unknownStockStatus'
    ) | translateSafe
    }}
</ng-container>
